import { state$ } from "@internal/auth";
import {
  AppErrorBoundary,
  initSentry,
  installGlobalErrorHandlers,
  wireSentryUserToAuth,
} from "@internal/error-handling";
import { createRoot } from "react-dom/client";
import "@/styles.css";
import { getDb, getDbForUser } from "@/lib/db";
import { startReplicationOnAuth } from "@/lib/replication";
import { registerServiceWorker } from "@/lib/sw";
import { App } from "./App";

const DAILY_PLANNER_SENTRY_DSN =
  "https://93d0737ce2305d673cb295a96f02751b@o4511315141984256.ingest.de.sentry.io/4511423336677456";

initSentry({
  dsn: DAILY_PLANNER_SENTRY_DSN,
  app: "daily-planner",
  release: `daily-planner@${process.env.GIT_SHA ?? "dev"}`,
  force:
    typeof window !== "undefined" &&
    (window as { __E2E_FORCE_SENTRY__?: boolean }).__E2E_FORCE_SENTRY__ ===
      true,
});
installGlobalErrorHandlers();
wireSentryUserToAuth(state$);

if (process.env.NODE_ENV !== "production") {
  (
    window as unknown as {
      __E2E__: {
        getDb: typeof getDb;
        getDbForUser: typeof getDbForUser;
      };
    }
  ).__E2E__ = { getDb, getDbForUser };
}

startReplicationOnAuth();
registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>,
);
